import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsumoEditarComponent } from './consumo-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ConsumoEditarComponent}
  ])],
  exports: [RouterModule]
})
export class ConsumoEditarRoutingModule { }
